import React from 'react';
import {observer} from 'mobx-react';
import Subnav from '../../Subnav';
import {Button, Layout, InteractiveTable, EmployeeNameWithAvatar} from 'components';
import {withState, endpoints, types} from 'shared/core';
import {PerformanceReviewReviewee} from 'stores/performance_reviews';
import {FormattedMessage} from 'react-intl';
import ReviewerAvatars from '../../../../manage/components/reviewees/components/ReviewerAvatars';
import ShareWithRevieweeModal from './ShareWithRevieweeModal';
import {TeamContainerState} from '../state';
import {absoluteDateFormatter} from 'shared/tools';

const ShareButton = observer(({uiState, model}) => {
  const {cycle} = uiState;

  if (!cycle.managerType) {
    return null;
  }

  return (
    <Button
      trait='default'
      size='sm'
      onClick={() => uiState.openShareWithRevieweeModal(model)}
    >
      <FormattedMessage id={`performance_reviews.view.Share`}/>
    </Button>
  );
});

const RevieweeActionButton = observer(({uiState, model}) => {
  const {cycle} = uiState;

  if (model.sharedAt){
    return <FormattedMessage
      id={`performance_reviews.view.${!!cycle.managerType ? 'SHARED_AT_MESSAGE' : 'CLOSED_AT_MESSAGE'}`}
      values={{sharedAt: absoluteDateFormatter(model.sharedAt)}}
    />;
  }
   else {
    return <ShareButton uiState={uiState} model={model}/>;
  }
});

const COLUMNS = [
  {
    header: 'performance_reviews.view.Reviewee',
    width: 4,
    render: model => <EmployeeNameWithAvatar employee={model.employee}/>
  },
  {
    header: 'performance_reviews.manage.Reviewers',
    width: 4,
    component: ReviewerAvatars
  },
  {
    header: 'performance_reviews.view.Status',
    width: 2,
    render: model => <FormattedMessage id='performance_reviews.view.REVIEWS_RECEIVED'
                                       values={{received: model.completedReviews, total: model.totalReviews}}/>
  },
  {
    width: 2,
    className: 'right-align',
    component: RevieweeActionButton
  }
];

const TeamContainer = observer(({ uiState}) => {
  const {cycle, match, scope} = uiState;

  return (
    <div>
      <Subnav title={cycle.name} match={match} scope={scope}/>
      <Layout>
        <InteractiveTable
          backPath='team'
          match={match}
          showLinks={false}
          columns={COLUMNS}
          uiState={uiState}
          onMount={agent => uiState.setInteractiveAgent(agent)}
          showPath={(model) => `/reviews/reviews/${cycle.id}/reviewee/${model.id}/employee/${model.employee.id}/${model.employee.urlSlug}/team`}
          proxy={{
            type: 'async',
            modelType: types.PERFORMANCE_REVIEWS.REVIEWEE,
            model: PerformanceReviewReviewee,
            endpoint: endpoints.PERFORMANCE_REVIEWS.REVIEWEES.TEAM.with(match.params.cycleId)
          }}/>
      </Layout>
      <ShareWithRevieweeModal uiState={uiState}/>
    </div>
  );
});

export default withState(TeamContainer, TeamContainerState);
